<template>
  <div v-bind:class="{ 'rtg-modal':true, show:show }" @click="close">
    <div class="rtg-modal-container">
      <div class="rtg-modal-content" @click.stop>
        <div class="top"><span>NOTES TO DRIVER</span></div>
        <div class="confirmation">
          <div>
            <div v-html="message"></div>
            <div class="button cta success" @click="close">OK</div>
          </div>

          <transition name="fade">
            <div class="loader" v-show="loading">
              <i class="fas fa-spinner fa-spin fa-4x"></i>
              Please wait...
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notes-modal',
  data () {
    return {
      error: '',
      success: false
    }
  },
  computed: {
    show () { return this.$store.state.laxit.notes.show },
    message () {
      if(Array.isArray(this.$store.state.laxit.notes.message)){
        let rsvp = this.$store.state.laxit.notes.message
        let message = rsvp.map((item)=>{
          return `<div class="message"><a href='/#/reservation/${item.rsvpID}' target="_blank">${item.rsvpID}</a>: ${item.notes}</div>`})
        return message.join("\n")
      } else {
        return `<label class="message">${this.$store.state.laxit.notes.message}</label>` }
      },
    loading () { return this.$store.state.laxit.notes.loading },
    rtgSuccess () { return this.$store.state.laxit.notes.success }
  },
  methods: {
    close () {
      if (this.loading) { return }
      this.error = ''
      this.success = false
      this.$store.commit('laxit/setNotesMessage', '')
      this.$store.commit('laxit/setNotesShow', false)

      // if (this.rtgSuccess && this.$route.name === 'RsvpDetails') {
      //   this.$store.commit('dispatch/setReadyToGoSuccess', false)
      //   location.reload()
      // }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.rtg-modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;

  &.show{
    top: 0;
    opacity: 1;
  }
}

.rtg-modal-container {
  display: table-cell;
  vertical-align: middle;
}

.rtg-modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 500px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  overflow: hidden;
}

.top {
  background-color: #0d79f2;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding: 10px 0;
}
.confirmation{
  padding:30px;
  position: relative;

  label{
    display:block;
    margin-bottom: 30px;
    font-size:15px;
    font-weight: 600;
    color:#444;
  }
  .button{ margin: 0 5px; }
  .error i{
    display: block;
    margin-bottom: 10px;
    color: #ecaa32;
  }
  .success i{
    display: block;
    margin-bottom: 10px;
    color: #26d97a;
  }
  .loader{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    font-weight: 600;
    color: #333;
    background: rgba(255,255,255, .8);

    i{
      margin-top: 30px;
      color:#2669bd;
      display: block;
    }
  }
}
</style>

<style scoped>
div >>> .message {
    display:block;
    margin-bottom: 30px;
    font-size:15px;
    font-weight: 600;
    color:#444;
  }
</style>>



// WEBPACK FOOTER //
// src/components/Laxit/NotesModal.vue